import React from 'react';
import { Link } from 'react-router-dom';
import './ISO20000.css';

const ISO20000 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 20000-1 Information Technology Service Management System</h1>
            <h2 className="page-subtitle">Your Business's Assurance in Technology Services: ISO 20000-1</h2>
            <div className="page-text-content">
              <p>
                Today's business world is becoming increasingly complex with the rapid advancement of 
                technology. Companies turn to the ISO 20000-1 Information Technology Service Management 
                System to effectively manage and sustain IT services. This comprehensive standard aims to 
                guide businesses in managing IT services to enhance reliability, performance, and customer 
                satisfaction.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is a globally recognized professional service provider 
                in certification and accreditation. Focusing on customer satisfaction and reliability, the 
                company assists businesses in obtaining certification services under various standards to help 
                them gain a competitive advantage.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 20000-1?</h2>
            <div className="page-text-content">
              <p>
                ISO 20000-1 is an international standard in the field of Information Technology Service 
                Management. This standard is created to enable organizations to effectively manage their IT 
                services, improve service quality, and ensure customer satisfaction. NQC (Nova Quality 
                Certification Agency) promotes continuous improvement and helps businesses stand out in the 
                global competitive environment by complying with the ISO 20000-1 standard.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 20000-1:</h2>
            <div className="page-text-content">
              <p>
                Compliance with ISO 20000-1 brings several advantages to businesses, including:
              </p>
            </div>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">Improvement in Service Quality</h3>
                <p className="advantage-description">
                  ISO 20000-1 encourages businesses to continuously improve IT services to enhance service 
                  quality.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Increase in Customer Satisfaction</h3>
                <p className="advantage-description">
                  The requirements of the standard support effective IT service management to enhance 
                  customer satisfaction and meet customer expectations.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Operational Efficiency</h3>
                <p className="advantage-description">
                  The standard ensures effective management of business processes and increases efficiency 
                  in operational processes.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Risk Management and Reliability</h3>
                <p className="advantage-description">
                  ISO 20000-1 provides a framework for identifying and managing potential risks in IT services, 
                  thereby increasing the reliability of businesses.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">International Competitive Advantage</h3>
                <p className="advantage-description">
                  ISO 20000-1 certification provides businesses with a competitive advantage in the global 
                  market and enhances international recognition.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 20000-1 Process with NQC (Nova Quality Certification Agency):</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) provides comprehensive support to its customers in 
                obtaining ISO 20000-1 certification. The process includes the following steps:
              </p>
            </div>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Application and Planning</h3>
                <p className="process-description">
                  The customer initiates the application process and plans the necessary steps for 
                  certification.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Documentation and Compliance Assessment</h3>
                <p className="process-description">
                  Relevant documents are prepared, and NQC experts assess the organization's compliance with 
                  ISO 20000-1 requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Audit</h3>
                <p className="process-description">
                  Following document preparations, NQC experts conduct an audit to evaluate the 
                  organization's compliance with ISO 20000-1 standards.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. Certification and Continuous Improvement</h3>
                <p className="process-description">
                  Upon successful audit, the organization receives ISO 20000-1 certification and continues 
                  to maintain standards through continuous improvement efforts.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Conclusion</h2>
            <div className="page-text-content">
              <p>
                The ISO 20000-1 Information Technology Service Management System enhances customer 
                satisfaction and helps businesses gain a competitive edge by effectively managing IT services. 
                NQC (Nova Quality Certification Agency) facilitates the ISO 20000-1 certification process 
                and contributes to the success of businesses by providing professional support.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO20000;

